import styled from 'styled-components';
import CustomMedia from 'util/custom-media-query';
import FontStyles from 'constants/font-styles';
import { applyStyles } from 'util/helpers';
import Colors from 'constants/colors';

const BlockHeaderCenter = styled.h3`
  position: relative;
  text-align: center;

  &:after {
    content: ' ';
    position: absolute;
    left: calc(100% - 50% - 28px);
    bottom: 0;
    width: 56px;
    border: 0;
    border-top: 1px solid ${Colors.orange1};
    margin-left: 0;
  }
`;

const pcStyle = CustomMedia.greaterThan('umedium')`
  ${FontStyles.text13};
  padding-bottom: 18px;
  margin: 88px 0;
`;

const spStyle = CustomMedia.lessThan('medium')`
  ${FontStyles.text13};
  padding-bottom: 12px;
  margin: 64px 0 48px;
`;

export default applyStyles(BlockHeaderCenter)(pcStyle, spStyle);



// WEBPACK FOOTER //
// ./src/components/common/BlockHeaderCenter/index.js